
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SaasInstance } from '@/types/userRole';

interface InstanceHeaderProps {
  instance: SaasInstance;
  id: string;
  user: any;
}

const InstanceHeader: React.FC<InstanceHeaderProps> = ({ instance, id, user }) => {
  const navigate = useNavigate();
  
  // Use instance.domain or instance.subdomain if domain is not available
  const displayDomain = instance.domain || (instance.subdomain ? `${instance.subdomain}.referme.site` : '');
  
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
      <div>
        <div className="flex items-center">
          <h1 className="text-2xl font-bold text-gray-900">{instance.name}</h1>
          <span className="ml-3 px-3 py-1 text-xs font-semibold text-white rounded-full bg-purple-600">
            {user?.role ? (user.role.charAt(0).toUpperCase() + user.role.slice(1)) : 'SuperAdmin'}
          </span>
        </div>
        <p className="text-gray-600">Instance management and analytics</p>
        <div className="mt-2 px-3 py-1.5 bg-primary/10 text-primary rounded-md inline-flex items-center">
          <span className="text-sm font-medium">{displayDomain}</span>
        </div>
      </div>
      <div className="mt-4 sm:mt-0 flex gap-2">
        <Button variant="outline" onClick={() => navigate('/super-admin/instances')}>
          Back to Instances
        </Button>
        <Button variant="outline" onClick={() => navigate(`/super-admin/instance/${id}/payments`)}>
          View Payments
        </Button>
      </div>
    </div>
  );
};

export default InstanceHeader;
